export enum FilterPillStyle {
  outlineBlue = "outlineBlue",
  outlineIndigo = "outlineIndigo",
  defaultTopics = "defaultTopics",
}
